import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import AOS from 'aos'
import throttle from 'lodash/throttle';
import '../../node_modules/jquery-parallax.js/parallax.min.js'
import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange, } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
import './_acf-map'
import './_fixed-header'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
import './_faqs_accordion'
import './_fragmentURLs'
import './_ie'

// Foundation
$(document).foundation();

// Inline SVG
inlineSVG();

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {

    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    lazyOembeds();
    lazyInterchange();

}, false);

// Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );

// AOS
AOS.init();
